import { t } from 'i18next';
import { useState } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useInput } from '../../hooks';
import Button from './Button/Button';
import Content from './Content';
import Form from './Form';
import { TotpModal } from './Home/HomeAuth';
import EmailValidationModal from './Modals/EmailValidationModal';
import { ForgotPasswordModal } from './Modals/ForgotPasswordModal';
import { useLogin } from './Modals/LoginModal';
import PasswordInput from './PasswordInput';

function Login() {
    const navigate = useNavigate();
    const login = useLogin();

    const [empty, setEmpty] = useState<boolean>();
    const emptyUsername = t('Enter Email');
    const emptyPassword = t('Enter password');

    const [username, resetUsername] = useInput('');
    const [password, resetPassword] = useInput('');
    const [error, setError] = useState('');
    const [showTotp, setShowTotp] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showForgot, setShowForgot] = useState(false);

    function resetForm() {
        resetUsername();
        resetPassword();
    }

    function onLogin() {
        setError('');
        let isEmpty = false;
        if (!username.value) {
            isEmpty = true;
        }
        if (!password.value) {
            isEmpty = true;
        }
        setEmpty(isEmpty);
        if (isEmpty) {
            return;
        }
        login(username.value, password.value, undefined, () => setShowTotp(true), () => {
            resetForm();
            if (window.location.pathname.startsWith('/public-') && !window.location.pathname.startsWith('/public-showcase')) {
                navigate(`/${window.location.pathname.slice(8)}`);
            }
        });
    }

    return (
        <Content>
            <EmailValidationModal isOpen={showRegistration} onClose={() => setShowRegistration(false)} />
            <ForgotPasswordModal isOpen={showForgot} onClose={() => setShowForgot(false)} />
            <TotpModal user={username.value} password={password.value} isOpen={showTotp} onClose={() => setShowTotp(false)} onSuccess={() => console.log('success')} />
            <div className="welcome-page">
                <h1 className="welcome-page__heading">
                    <Trans>Sign</Trans>
                </h1>
                <div className="welcome-register">
                    <Form action="" className="form-login">
                        <div className={'form__item' + ((error || (empty && !username.value)) ? ' _error' : '')}>
                            <input {...username} name="username" className={'form__input _required' + ((error || (empty && !username.value)) ? ' _error' : '')} required placeholder={t('Enter Email')} />
                            {(empty && !username.value) && <div className="form__input-error-message">{emptyUsername}</div>}
                            {error && <div className="form__input-error-message">{error}</div>}
                        </div>
                        <div
                            className={'form__item' + ((error || (empty && !password.value)) ? ' _error' : '')}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    onLogin();
                                }
                            }}>
                            <PasswordInput {...password} name="password" className={'_required' + ((error || (empty && !password.value)) ? ' _error' : '')} required placeholder={t('Enter password')} />
                            {(empty && !password.value) && <div className="form__input-error-message">{emptyPassword}</div>}
                        </div>
                        <div className="form__submit">
                            <Button type="button" onClick={() => onLogin()}>
                                <Trans>Sign in</Trans>
                            </Button>
                        </div>
                        <div className="form__link-btn" onClick={() => setShowForgot(true)}>
                            <div className="link link-accent">
                                <Trans>Recover password</Trans>?
                            </div>
                        </div>
                        <div className="form__link-btn">
                            <div className="link link-accent" onClick={() => setShowRegistration(true)}>
                                <Trans>Register</Trans>
                            </div>
                        </div>
                        {/* <div className="form__link-btn">
                        <a href="welcome-restore.html" className="link-accent">Восстановить пароль</a>
                    </div>
                    <div className="form__link-btn">
                        <a href="welcome-register.html" className="link-accent">Зарегистрироваться</a>
                    </div> */}
                    </Form>
                </div>
            </div>
        </Content>
    );
}

export default Login;